import { createInjectionKey } from 'naive-ui/es/_utils'
import type { LearnInjection } from './types'

export const cloudLearnInjectionKey = createInjectionKey<LearnInjection>('erp-learn-cloud')
